import React from 'react';
import './Hello.css';

const Hello = () => {
    return (
        <div className='container'>
        	<h1 align='center'>Welcome to the Community<span role='img' aria-label='hello'>🙌</span></h1>
        </div>
    );
};

export default Hello;
